<template>
     <v-container>
        <v-toolbar :color="$store.state.UiColors.crudToolbarDetail">
            <v-toolbar-title>Configuración de Caja</v-toolbar-title>
        </v-toolbar >
            
        <v-card>
            <v-card-text>

                <v-container >
                    <v-alert v-if="noConfigurado" type="error">
                        Caja y Parámetros de Impresión Configurados
                    </v-alert>

                    <v-alert type="info">
                        A continuación, seleccione la caja predeterminada
                        y, en caso de imprimir con tickeadora, la dirección de la API de Impresión
                    </v-alert>

                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete v-model="config.cajaId" :items="listCajas"
                                        item-text="descripcion" item-value="id" label="" no-data-text="Seleccione una Caja" hide-details
                                        placeholder="Seleccione una Caja" :menu-props="{minWidth:'200'}"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row align="center">
                        <v-col cols="6">
                            <v-checkbox label="Configurar Impresión por Tickeadora" v-model="config.usarTickeadora" ></v-checkbox>
                        </v-col>
                        <v-col v-if="config.usarTickeadora">
                            <v-btn small text color="green" href="http://digital-minds.com.ar:50005/publish.htm" target="_blank"> <v-icon>cloud_download</v-icon> &nbsp; Ir a Sitio de Descarga Api</v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                    </v-row>
                    <v-row align="center" v-if="config.usarTickeadora">
                        <v-col>
                            <v-text-field label="Url Api" v-model="config.apiSerialPrint" persistent-hint hint="se utiliza en caso de impresión de recibo por tickeadora (la url por defecto es http://localhost:2167/smarter, sin espacios)"></v-text-field> 
                        </v-col>
                        
                        <v-col cols="3">
                            <v-btn color="info" @click="checkApi" v-if="config.apiSerialPrint != ''">Checkear Api</v-btn>
                        </v-col>

                        <v-col cols="2">
                            <v-autocomplete v-model="config.port" :items="puertosDisponibles"  v-if="config.apiSerialPrint != ''" 
                                label="Puertos COM" ></v-autocomplete>
                        </v-col>

                    </v-row>
                    
                    <v-row align="center">
                        <v-spacer></v-spacer>
                        <v-alert type="info"  v-if="config.usarTickeadora && config.apiSerialPrint != '' && puertosDisponibles.length ==0" width="300" align-end>
                            Presione el botón Checkear API para obtener una lista de los puertos disponibles en esta PC
                        </v-alert>
                </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn color="warning" @click="clear"><v-icon>delete</v-icon>&nbsp;Limpiar Configuración</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="save"><v-icon>save</v-icon>&nbsp;Guardar</v-btn>
            </v-card-actions>
        </v-card>
     </v-container>
</template>


<script>
import Vue from 'vue'
import { http } from '@/axios'

import axios from 'axios' // aparte para llamado a api serial print

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data () {
    return {
      temaOscuro: false,
      visible: false,
      puertosDisponibles: [],
      listCajas:[],
      config: {apiSerialPrint: '', puerto: '', cajaId: 0, canalVentaId: 0, usarTickeadora: false},      
    }
  },
  props:{     
  },
  async created () {    
    await this.loadCajas();
    await this.loadConfig();    
  },  
  computed:{
    ...mapGetters(['UiCustomUserSettings', 'user', 'DebugModeOn']),
    noConfigurado: function(){
        return !this.config || (this.config.cajaId ==0);
    }
  },
  methods: {    
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]), 
    crearConfig (){
        return {apiSerialPrint: '', puerto: '', cajaId: 0};
    },
    async loadConfig() {        
        var config = localStorage.getItem('localconfig');

        if(config == null)
            this.config = this.crearConfig();
        else
            this.config = JSON.parse(config);

        if(this.config != null && this.config.apiSerialPrint != ''){
            await this.checkApi();
        }

    },    
    async loadCajas(){            
        this.listCajas = [];            
        this.loading = true
        try {
            var result = await http.get('cajas/disponiblesporusuario?login=' + this.user.login);
            this.listCajas = result.list;
        } catch (error) {
            // Error
            this.alertError(error)
        }
        this.loading = false
    },
    async save(){
        //console.log(JSON.stringify( this.config))
        localStorage.setItem('localconfig', JSON.stringify( this.config))
        this.alertSuccess('La configuración ha sido guardada.');

        this.visible = false;
    },
    async clear(){
        this.config = this.crearConfig();
        await this.save();
    },
    async checkApi(){
        
        const instance = axios.create({
            baseURL: this.config.apiSerialPrint,
            timeout: 1000,
            headers: {'X-Custom-Header': 'foobar'}
        });

        var self = this;

        instance.get('/serialports', )
        .then(function (response) {
            console.log(response);

            self.puertosDisponibles = response.data;
        })
        .catch(function (error) {
            console.log(error);
        });

    },
    
  }
}
</script>